// You can write more code here

import { SizedElement } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/LayoutGroupUtils';
import { waitForMilliseconds } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import type CardDropSite from '@/game/prefabs/StudentGame/CardDropSite';

/* START OF COMPILED CODE */

export default class MinigameCardSlot extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// neutralOutline
		const neutralOutline = scene.add.nineslice(0, 0, "square-card-neutral-outline", undefined, 52, 68, 10, 10, 10, 10);
		neutralOutline.scaleX = 1.5;
		neutralOutline.scaleY = 1.5;
		neutralOutline.visible = false;
		this.add(neutralOutline);

		// padding
		const padding = scene.add.nineslice(0, 0, "square-card-positive-outline", undefined, 52, 68, 10, 10, 10, 10);
		padding.scaleX = 1.5;
		padding.scaleY = 1.5;
		padding.visible = false;
		this.add(padding);

		// slot
		const slot = scene.add.image(0, 0, "CardSlot");
		slot.scaleX = 1.5;
		slot.scaleY = 1.5;
		this.add(slot);

		this.neutralOutline = neutralOutline;
		this.slot = slot;

		/* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
	}

	private neutralOutline: Phaser.GameObjects.NineSlice;
	private slot: Phaser.GameObjects.Image;

	/* START-USER-CODE */

  origin?: {
    dropSite: CardDropSite;
    index: number;
    desiredPosition?: { x: number; y: number };
  };

  async showNeutralFeedback() {
    this.neutralOutline.setVisible(true);
    this.neutralOutline.setAlpha(0);
    const feedbackDuration = 400;
    this.scene.tweens.add({
      targets: this.neutralOutline,
      alpha: 1,
      duration: feedbackDuration,
      ease: 'Cubic.easeOut',
      yoyo: true,
    });
    await waitForMilliseconds(this.scene.time, feedbackDuration);
  }

  getDesiredPositionWorld() {
    return {
      x: this.getWorldTransformMatrix().tx,
      y: this.getWorldTransformMatrix().ty,
    };
  }

  getElementSize() {
    return new Phaser.Math.Vector2(
      this.slot.displayWidth,
      this.slot.displayHeight,
    );
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
